import { formatMoney } from '@betterment/js-runtime';
import { ListRow, Text } from '@betterment/samba-react';

import { CheckingUnavailableRow } from './CheckingUnavailableRow';
import { LeadingIcon } from './LeadingIcon';

import { useColorMode } from '../../../Shared/components-v2/color-mode/color-mode-state';
import { StyledLinkRow, titleCss } from '../../../Shared/components-v2/styled-link-row/StyledLinkRow';
import { urlBuilder } from '../../../Shared/urlBuilder';
import { CheckingAccountFragment as CheckingAccount } from '../graphql/query.envelopesCard.generated';

export const LegacyCheckingAccountRow: React.FC<{ account: CheckingAccount }> = ({ account }) => {
  const { colorMode } = useColorMode();
  const { remote } = account;
  const iconUrl = account.icon[colorMode];

  if (!remote) return CheckingUnavailableRow({ iconUrl });

  const { accountId, name, balance } = remote;

  return (
    <StyledLinkRow to={urlBuilder.getAppCheckingSummary.absolute({ accountId })} name={name}>
      <ListRow.LeadingAsset>
        <LeadingIcon url={iconUrl} />
      </ListRow.LeadingAsset>
      <ListRow.LeadingContent>
        <Text color="text" css={titleCss}>
          {name}
        </Text>
      </ListRow.LeadingContent>
      <ListRow.TrailingContent>
        <Text color="text">{formatMoney(balance)}</Text>
      </ListRow.TrailingContent>
    </StyledLinkRow>
  );
};
